// src/features/services/components/ServiceWorkspace.tsx
import type { Service } from './ServiceRow';
import { Workspace, WorkspaceSection, WorkspaceActions } from '../../../app/components/foundation';
import { ServiceWorkspaceHeader } from './ServiceWorkspaceHeader';
import { ServiceCustomerSection } from './ServiceCustomerSection';
import { ServiceDetailsSection } from './ServiceDetailsSection';
import { ServiceUsageSection } from './ServiceUsageSection';
import { ServiceBillingSection } from './ServiceBillingSection';
import { ServiceTimeline } from './ServiceTimeline';
import { ServiceActions } from './ServiceActions';

interface ServiceWorkspaceProps {
  service: Service | null;
  onClose: () => void;
}

/**
 * Service management detail panel — follows the same Workspace pattern
 * as `OrderWorkspace` / `CustomerWorkspace`. The compact `ServiceRow`
 * stays as the list identity; this is the full operational view opened
 * on row click.
 *
 * Sections render only fields that exist on `Service` today (id, name,
 * customerName, status, expiresAt); anything without a real data
 * source yet renders a neutral, explicitly-labeled placeholder instead
 * of invented data.
 */
export function ServiceWorkspace({ service, onClose }: ServiceWorkspaceProps) {
  if (!service) {
    return null;
  }

  return (
    <Workspace onClose={onClose} ariaLabel="فضای کاری سرویس" closeLabel="بستن فضای کاری سرویس">
      <ServiceWorkspaceHeader service={service} onClose={onClose} />

      <div className="flex-1 overflow-y-auto px-4">
        <WorkspaceSection title="جزئیات سرویس" defaultOpen>
          <ServiceDetailsSection service={service} />
        </WorkspaceSection>

        <WorkspaceSection title="مصرف">
          <ServiceUsageSection />
        </WorkspaceSection>

        <WorkspaceSection title="صورتحساب">
          <ServiceBillingSection />
        </WorkspaceSection>

        <WorkspaceSection title="مشتری" defaultOpen>
          <ServiceCustomerSection service={service} />
        </WorkspaceSection>

        <WorkspaceSection title="جدول زمانی">
          <ServiceTimeline />
        </WorkspaceSection>
      </div>

      <WorkspaceActions>
        <ServiceActions />
      </WorkspaceActions>
    </Workspace>
  );
}
